<template>
  <div class="order-detail-warp">
    <div class="container">
      <div class="form-box">
        <div class="form-cell">
          <div class="form-title">发票类型</div>
          <div class="form-tags category-tags">
            <div class="tag-item">
              <input
                type="radio"
                id="cat1"
                value="NORMAL"
                name="type"
                v-model="type"
                :disabled="!isEdit"
              />
              <label for="cat1">普通发票</label>
            </div>
            <div class="tag-item">
              <input
                type="radio"
                id="cat2"
                value="VATS"
                name="type"
                v-model="type"
                :disabled="!isEdit"
              />
              <label for="cat2">增值税专用发票</label>
            </div>
          </div>
        </div>
      </div>
      <div class="form-box" v-if="invoiceInfo">
        <div class="address-add-cell">
          <a class="address-add-info" :class="{ disable: !isEdit }" @click="isEdit && addInvoice()">
            <h3 class="info-head">发票抬头</h3>
            <div class="flex">
              <div class="info-content">
                <h4>{{ invoiceInfo.name }}</h4>
                <p>税号：{{ invoiceInfo.taxNumber }}</p>
              </div>
              <div class="go">
                <svg
                  width="10"
                  height="18"
                  viewBox="0 0 10 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.16406 17.0938C1.35938 17.0938 1.50586 17.0156 1.64258 16.8887L9.43555 9.47656C9.5918 9.33008 9.67969 9.1543 9.67969 8.94922C9.67969 8.74414 9.5918 8.55859 9.44531 8.42188L1.65234 1.01953C1.51562 0.892578 1.35938 0.814453 1.16406 0.814453C0.783203 0.814453 0.490234 1.10742 0.490234 1.48828C0.490234 1.66406 0.558594 1.83984 0.685547 1.9668L8.01953 8.94922L0.685547 15.9316C0.558594 16.0586 0.490234 16.2344 0.490234 16.4199C0.490234 16.8008 0.783203 17.0938 1.16406 17.0938Z"
                    fill="#999999"
                  />
                </svg>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="form-box" v-else>
        <div class="address-add-cell">
          <a class="address-add-btn" @click="addInvoice()">
            <svg
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.709 20.9102C16.1582 20.9102 20.6699 16.3984 20.6699 10.9492C20.6699 5.50977 16.1484 0.988281 10.6992 0.988281C5.25977 0.988281 0.748047 5.50977 0.748047 10.9492C0.748047 16.3984 5.26953 20.9102 10.709 20.9102ZM10.6895 15.8125C10.1328 15.8125 9.83984 15.4121 9.83984 14.8457V11.8086H6.63672C6.06055 11.8086 5.66016 11.5059 5.66016 10.9688C5.66016 10.4121 6.04102 10.0996 6.63672 10.0996H9.83984V6.86719C9.83984 6.30078 10.1328 5.90039 10.6895 5.90039C11.2363 5.90039 11.5586 6.28125 11.5586 6.86719V10.0996H14.7715C15.3672 10.0996 15.7383 10.4121 15.7383 10.9688C15.7383 11.5059 15.3477 11.8086 14.7715 11.8086H11.5586V14.8457C11.5586 15.4316 11.2363 15.8125 10.6895 15.8125Z"
                fill="#BDC5CF"
              />
            </svg>
            选择发票抬头
          </a>
        </div>
      </div>
      <div class="form-box" v-if="address">
        <div class="address-add-cell">
          <a class="address-add-info" :class="{ disable: !isEdit }" @click="isEdit && addAddress()">
            <h3 class="info-head">
              发票邮寄地址
              <div class="express" v-if="order.invoiceTrackInfo">
                {{ getTrackCompany(order.invoiceTrackInfo.trackCompany) }}
                <span v-if="order.invoiceTrackInfo.trackCompany">·</span
                >{{ order.invoiceTrackInfo.trackNumber }}
              </div>
            </h3>
            <div class="flex">
              <div class="info-content">
                <h4>
                  {{ address.consignee }}
                  <span>·</span>{{ address.mobile }}
                </h4>
                <p>
                  {{ address.province }}{{ address.city }}{{ address.county }}{{ address.detail }}
                </p>
              </div>
              <div class="go">
                <svg
                  width="10"
                  height="18"
                  viewBox="0 0 10 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.16406 17.0938C1.35938 17.0938 1.50586 17.0156 1.64258 16.8887L9.43555 9.47656C9.5918 9.33008 9.67969 9.1543 9.67969 8.94922C9.67969 8.74414 9.5918 8.55859 9.44531 8.42188L1.65234 1.01953C1.51562 0.892578 1.35938 0.814453 1.16406 0.814453C0.783203 0.814453 0.490234 1.10742 0.490234 1.48828C0.490234 1.66406 0.558594 1.83984 0.685547 1.9668L8.01953 8.94922L0.685547 15.9316C0.558594 16.0586 0.490234 16.2344 0.490234 16.4199C0.490234 16.8008 0.783203 17.0938 1.16406 17.0938Z"
                    fill="#999999"
                  />
                </svg>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div class="form-box" v-else>
        <div class="address-add-cell">
          <a class="address-add-btn" @click="addAddress()">
            <svg
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.709 20.9102C16.1582 20.9102 20.6699 16.3984 20.6699 10.9492C20.6699 5.50977 16.1484 0.988281 10.6992 0.988281C5.25977 0.988281 0.748047 5.50977 0.748047 10.9492C0.748047 16.3984 5.26953 20.9102 10.709 20.9102ZM10.6895 15.8125C10.1328 15.8125 9.83984 15.4121 9.83984 14.8457V11.8086H6.63672C6.06055 11.8086 5.66016 11.5059 5.66016 10.9688C5.66016 10.4121 6.04102 10.0996 6.63672 10.0996H9.83984V6.86719C9.83984 6.30078 10.1328 5.90039 10.6895 5.90039C11.2363 5.90039 11.5586 6.28125 11.5586 6.86719V10.0996H14.7715C15.3672 10.0996 15.7383 10.4121 15.7383 10.9688C15.7383 11.5059 15.3477 11.8086 14.7715 11.8086H11.5586V14.8457C11.5586 15.4316 11.2363 15.8125 10.6895 15.8125Z"
                fill="#BDC5CF"
              />
            </svg>
            选择发票邮寄地址
          </a>
        </div>
      </div>
      <div class="address-edit-btns" v-if="isEdit">
        <van-button round block type="primary" @click="applyInvoice()">保存</van-button>
        <van-button round block type="default" @click="cancle()">取消</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/components/axios";

export default {
  data() {
    return {
      id: this.$route.query.id || null,
      status: this.$route.query.status || "read",
      type: "NORMAL",
      trackCompany: [
        {
          lable: "顺丰",
          key: "SHUNFENG",
        },
        {
          lable: "申通",
          key: "SHENTONG",
        },
        {
          lable: "中通",
          key: "ZHONGTONG",
        },
        {
          lable: "圆通",
          key: "YUANTONG",
        },
        {
          lable: "德邦",
          key: "DEBANG",
        },
        {
          lable: "韵达",
          key: "YUNDA",
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    if (this.order && this.order.invoiceInfo) {
      this.type = this.order.invoiceInfo.type;
    }
  },
  computed: {
    order() {
      return this.$store.state.order;
    },
    invoiceInfo() {
      if (this.$store.state.invoice) {
        return this.$store.state.invoice;
      }
      if (this.order && this.order.invoiceInfo) {
        return this.order.invoiceInfo;
      }
      return null;
    },
    address() {
      let address = null;
      if (this.order && this.order.invoiceAddress) {
        if (this.order.invoiceAddress.mobile) {
          address = this.order.invoiceAddress;
        }
      }
      if (this.$store.state.invoiceAddress) {
        address = this.$store.state.invoiceAddress;
      }
      return address;
    },
    isEdit() {
      const order = this.$store.state.order;
      let edit = true;
      if (order) {
        const state = order.invoiceState;
        if (state === "INVOICING" || state === "INVOICED" || order.invoiceInfo) {
          edit = false;
        }
      }
      return edit;
    },
  },
  watch: {
    $route: "getData",
  },
  methods: {
    getData() {
      const { id } = this.$route.query;
      if (id) {
        this.$store.dispatch("getOrder", id);
      }
    },
    addInvoice() {
      const { id } = this.$route.query;
      this.$router.push({
        path: "/invoice-list",
        query: {
          id: id,
        },
      });
    },
    addAddress() {
      const { id } = this.$route.query;
      this.$router.push({
        path: "/address-list",
        query: {
          id: id,
          type: 3,
        },
      });
    },
    applyInvoice() {
      if (this.invoiceInfo) {
        if (this.address) {
          let { id, bank, bankAccount, companyAddress, mobile, name, taxNumber } = this.invoiceInfo;
          const data = {
            id: this.$route.query.id,
            invoiceAddress: this.address,
            invoiceInfo: {
              id,
              bank,
              bankAccount,
              companyAddress,
              mobile,
              name,
              taxNumber,
              type: this.type,
            },
          };
          api
            .put(`/order_record/apply_invoice?invoiceInfoId=${this.invoiceInfo.id}`, data)
            .then((res) => {
              if (res.data.code === 200) {
                this.$toast.success("申请开票成功");
                this.$store.commit("storeInvoiceAddress", null);
                this.getData();
                this.$router.push(`/order-detail/${this.id}`);
              } else {
                this.$toast.fail("申请开票失败");
              }
            });
        } else {
          this.$toast("请选择发票邮寄地址！");
        }
      } else {
        this.$toast("请选择发票抬头！");
      }
    },
    cancle() {
      const { id } = this.$route.query;
      this.type = "NORMAL";
      this.$store.commit("storeInvoice", null);
      this.$router.push(`/order-detail/${id}`);
    },
    getTrackCompany(key) {
      if (key) {
        const item = this.trackCompany.find((x) => x.key === key);
        return item.lable;
      }
    },
  },
};
</script>
<style lang="less">
.back-btn,
.footer {
  display: none;
}
.van-swipe-cell {
  .delete-button {
    height: 100%;
    border-radius: 10px;
  }
  .van-button::before {
    display: none;
  }
}

.van-submit-bar .van-submit-bar__text {
  & > .van-submit-bar__price {
    margin-right: 4px;
  }
  .van-submit-bar__suffix-label {
    text-decoration: line-through;
    color: #999;
    font-size: 12px;
  }
}
</style>
